import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Email from '@material-ui/icons/MailOutline';
import LockOutline from '@material-ui/icons/LockOutlined';
// core components
import Button from 'components/core/CustomButtons/Button';
import Card from 'components/core/Card/Card';
import BrandMark from 'components/core/BrandMark';
import AuthField from 'components/core/AuthField';
import LoginStyle from 'assets/jss/views/LoginStyle';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CardContent from '@material-ui/core/CardContent';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import ForgetPassword from './ForgetPassword';
import ResetPassword from './ResetPassword';
import TwoFA from './TwoFA';
import { VALIDATE_AUTH } from '../../actions';
import { axiosWithNoErrorHandling } from '../../request';

class Login extends React.Component {
  state = {
    email: '',
    password: '',
  };

  componentDidMount() {
    if (window.location.href.indexOf('reset') > -1) {
      this.setState({ reset: true });
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleEmailChange = evt => {
    this.setState({ email: evt.target.value });
  };

  handlePasswordChange = evt => {
    this.setState({ password: evt.target.value });
  };

  handleOpenForgetPassword = () => {
    this.setState({ forget: true });
  };

  handleCancelForgetPassword = () => {
    this.setState({ forget: false });
  };

  handleSearchTermSubmit = e => {
    e.preventDefault();
    const { email, password } = this.state;
    const url = process.env.REACT_APP_API_URL;
    axiosWithNoErrorHandling
      .post(`${url}/v1/auth/login`, { email, password })
      .then(res => {
        if (res.status === 200) {
          this.props.dispatch(VALIDATE_AUTH(res.data.access_token));
          this.setState({ TwoFA: true });
        }
      })
      .catch(() => this.setState({ open: true }));
  };

  renderAuthChrome = children => {
    const { classes } = this.props;
    return (
      <div className={`${classes.authShell} premium-fade-in`}>
        <div className={classes.brandRow}>
          <BrandMark height={52} />
          <p className={classes.brandTagline}>مكتب معالجة طلبات الأفراد · تمكين</p>
        </div>
        {children}
      </div>
    );
  };

  render() {
    const { classes } = this.props;
    if (this.state.TwoFA) {
      return this.renderAuthChrome(<TwoFA />);
    }
    if (this.state.forget) {
      return this.renderAuthChrome(<ForgetPassword onCancel={this.handleCancelForgetPassword} />);
    }
    if (this.state.reset) {
      return this.renderAuthChrome(<ResetPassword history={this.props.history} />);
    }

    return this.renderAuthChrome(
      <React.Fragment>
        {this.state.status ? (
          <Card className={classes.card}>
            <CardContent>
              <h5 className={classes.cardTitleRed}>نعتذر. تم تعطيل حساب المستخدم</h5>
            </CardContent>
          </Card>
        ) : null}
        <form className={classes.loginBox} onSubmit={this.handleSearchTermSubmit}>
          <p className={classes.formTitle}>تسجيل الدخول</p>
          <p className={classes.formSubtitle}>أدخل بيانات حسابك للمتابعة</p>
          <div className={classes.fields}>
            <AuthField
              label="البريد الإلكتروني"
              id="email"
              type="email"
              value={this.state.email}
              onChange={this.handleEmailChange}
              autoFocus
              icon={<Email />}
            />
            <AuthField
              label="الرقم السري"
              id="password"
              type="password"
              value={this.state.password}
              onChange={this.handlePasswordChange}
              icon={<LockOutline />}
            />
          </div>
          <div className={classes.submitRow}>
            <Button type="submit" color="primary" className={classes.submitBtn}>
              دخول
            </Button>
          </div>
          <div className={classes.forgetPassword}>
            <button
              type="button"
              className={classes.forgetBtn}
              onClick={this.handleOpenForgetPassword}
            >
              استعادة كلمة المرور؟
            </button>
          </div>
          <Snackbar
            className={classes.snackbar}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={!!this.state.open}
            autoHideDuration={5000}
            onClose={this.handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
              className: classes.snackbarContent,
            }}
            message={<span id="message-id">الرجاء التحقق من البيانات المدخلة.</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.handleClose}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </form>
      </React.Fragment>,
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};
export default compose(
  withStyles(LoginStyle),
  connect(),
)(Login);
